import { colors } from '@/theme/colors';
import styled from 'styled-components';

type MultiLineTextProps = {
  translationKey?: string;
};

export const MultiLineText = ({ translationKey = '' }: MultiLineTextProps) => {
  return (
    <Span
      dangerouslySetInnerHTML={{
        __html: translationKey.replace(/\n/g, '<br />'),
      }}
    />
  );
};

const Span = styled.span`
  strong {
    color: ${colors.infoHover};
  }
`;
